module.exports = __webpack_public_path__ + "static/media/banner.338831d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/projects/yelp/src/banner.jpg
// module id = 649
// module chunks = 0